module.exports = __webpack_public_path__ + "img/delivery.f66d2d4f.svg";